"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

function makePureComponentClass() {
  if (_react.default.PureComponent) {
    return _react.default.PureComponent;
  }

  var shallowCompare = _react.addons.shallowCompare;
  return (
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(PureComponent, _React$Component);

      function PureComponent() {
        (0, _classCallCheck2.default)(this, PureComponent);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PureComponent).apply(this, arguments));
      }

      (0, _createClass2.default)(PureComponent, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          return shallowCompare(this, nextProps, nextState);
        }
      }]);
      return PureComponent;
    }(_react.default.Component)
  );
}

var _default = makePureComponentClass();

exports.default = _default;
module.exports = exports.default;